//#region IMPORTS
import React, { Fragment, useState, useEffect, useRef } from 'react';
import { ToastProvider, useToasts } from 'react-toast-notifications';
import LabelChargeData from '../../components/Label/labelChargeData';
import LabelTitle from '../../components/Label/labelTitle';
import Select from 'react-select';
import language from '../../config/es';
import Moment from 'moment';
import Datetime from 'react-datetime';
//styles
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Backdrop from '@material-ui/core/Backdrop';
import {Container, FormGroup, Alert, Tabs, Tab, Row, Col, Card } from 'react-bootstrap';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Switch from '@material-ui/core/Switch';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
//Redux
import { getPermissions, getConciliationDaily, getBankingList } from '../../redux/conciliationMonitor.duck';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../redux/store/hooks';
import { findSocieties } from '../../redux/society.duck';
//Partials
import PartialDaily from './partialDaily';
import PartialBank from './partialBank';
import PartialIncome from './partialIncome';
//Permissions
import dictionary from '../../config/dictionary';
import Lottie from "lottie-react";
import loadingInit from "../../assets/json/load-fragmented-square.json";
//Session user
import SessionConfig from '../../config/session_config';
//#endregion IMPORTS

//#region INIT COMPONENTS
const useStyles = makeStyles((theme) => ({
  sectionDiv: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  rootPaper: {
    padding:theme.spacing(2),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

const ConciliationSwitch = withStyles((theme) => ({
  root: {
    width: 28,
    height: 16,
    padding: 0,
    display: 'flex',
  },
  switchBase: {
    padding: 2,
    color: theme.palette.common.white,
    '&$checked': {
      transform: 'translateX(12px)',
      color: theme.palette.common.white,
      '& + $track': {
        opacity: 1,
        backgroundColor: '#343e51',
        borderColor: '#343e51',
      },
    },
  },
  thumb: {
    width: 12,
    height: 12,
    boxShadow: 'none',
  },
  track: {
    border: `1px solid '#28a745'`,
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: '#28a745',
  },
  checked: {},
}))(Switch);

const columns = [
  {
    name: language.messages.gridConciliationDaily.operationNumber,
    sortable: true,
    selector: "operationNumber",
    wrap: true,
    cell: (row) => (
      <span>
        <div className="text-capitalize">{row.operationNumber}</div>
        <div className="text-capitalize small">{language.messages.gridConciliationDaily.trace}: <strong>{row.trace}</strong></div>
      </span>
    ),
  },
  {
    name: language.messages.gridConciliationDaily.clientName,
    sortable: true,
    selector: "clientName",
    wrap: true,
    grow: 2,
    cell: (row) => (
      <div className="text-capitalize">{row.clientName}</div>
    ),
  },
  {
    name: language.messages.gridConciliationDaily.sap,
    sortable: true,
    selector: "clientDni",
    wrap: true,
    cell: (row) => (
      <div className="text-capitalize">{row.clientId}</div>
    ),
  },
  {
    name: language.messages.gridConciliationDaily.billNumber,
    sortable: true,
    selector: "billNumber",
    wrap: true,
    cell: (row) => (
      <div className="text-capitalize">{row.billNumber}</div>
    ),
  },
  {
    name: language.messages.gridConciliationDaily.dateIssue,
    sortable: true,
    selector: "dateIssue",
    wrap: true,
    cell: (row) => (
      <div className="text-capitalize">{row.dateIssue}</div>
    ),
  },
  {
    name: language.messages.gridConciliationDaily.amount,
    sortable: true,
    selector: "amount",
    wrap: true,
    cell: (row) => (
      <div>
      { row.state === 0 || row.statusBank === 'NOT_MATCH'?
        <span>
          <div className="text-capitalize">{row.amount > 0? "S: ":""} <strong>{row.amount > 0?Number.parseFloat(row.amount).toLocaleString('en'):""}</strong></div>
          <div className="text-capitalize">{row.amountB > 0? "B: ":""} <strong>{row.amountB > 0?Number.parseFloat(row.amountB).toLocaleString('en'):""}</strong></div>
        </span>:<div className="text-capitalize">{Number.parseFloat(row.amount).toLocaleString('en')}</div>
      }
      </div>
    ),
  },
  {
    name: language.messages.gridConciliationDaily.billAmount,
    sortable: true,
    selector: "billAmount",
    wrap: true,
    cell: (row) => (
      <div>
      { row.state === 0 || row.statusBank === 'NOT_MATCH'?
        <span>
          <div className="text-capitalize">{row.billAmount > 0? "S: ":""} <strong>{row.billAmount > 0?Number.parseFloat(row.billAmount).toLocaleString('en'):""}</strong></div>
          <div className="text-capitalize">{row.billAmountB > 0? "B: ":""} <strong>{row.billAmountB > 0?Number.parseFloat(row.billAmountB).toLocaleString('en'):""}</strong></div>
        </span>:<div className="text-capitalize">{row.billAmount.toLocaleString('en')}</div>
      }
      </div>
    ),
  },
  {
    name: language.messages.gridConciliationDaily.state,
    sortable: true,
    selector: "state",
    wrap: true,
    grow: 1,
    cell: (row) => (
      <span>
        {
          row.state !== "null"?<div className=" text-uppercase small">{
            row.statusBank=== "NOT_MATCH"? "Diferencia de Montos":"ACEPTADO"
          }</div>:""
        }
      </span>
    ),
  },
];
//#endregion INIT COMPONENTS

const ConciliationMonitor = () => {
    //#region VARIABLES_INIT
    const ref = useRef();
    const classes = useStyles();
    const { addToast } = useToasts();
    const dispatch = useAppDispatch();
    const [loadInit, setLoadInit] = useState(true);
    const [showLoadingBankingList, setShowLoadingBankingList] = useState(true);
    const [msgRestricted, setMsgRestricted] = useState('');

    const [pendingServiceInit, setPendingServiceInit] = useState(true);
    const [matchAmount, setMatchAmount] = useState(true);
    const [open, setOpen] = useState(false);
    const [showLoadingSociety, setShowLoadingSociety] = useState(false);

    const [data] = useState({
        society: { value: 0, label: '', error: '' },
        societies: [],
        selectedCountry: '',
        selectedBanking: '',
        optionConciliation: 'daily',
        dateIssue: new Date(),
        action: dictionary.configApp.action,
        auth: JSON.parse(sessionStorage.getItem('user'))
    });
    const [dataFilter, setDataFilter] = useState({
        banking: { value: '', label: '', error: '' },
        bankingList: [],

        errors: [],
        filterBankCode: false
    });
    const refreshDataFilter = () => {
        setDataFilter({...dataFilter});
    };
    const [conciliationData, setConciliationData] = useState({
        totalDaily: {
            bank: 0,
            income: 0,
            total: 0,
            difference: 0,
            coin: '',
            sizeBank: 0,
            sizeIncome: 0,
            dateIssue: ''
        },
        history: false
    });
    const refreshConciliationData = () => {
        setConciliationData({...conciliationData});
    };
    //#en
    data.societies = useSelector((store) => store.societyReducer.societies);
    dataFilter.bankingList = useSelector((store) => store.conciliationMonitorReducer.bankingList);
    //#endregion VARIABLES_INIT

    //#region LIFECYCLE
    useEffect(() => {
      void initPermissions();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
      ref.current.onRefreshCurrentSession();
    }, [dataFilter, data]);
    //#endregion LIFECYCLE

    //#region LOAD_DATA
    const initPermissions = async () => {
        const res = await dispatch(getPermissions(
          data.auth.id.user.username, 
          data.action.list));
        if(res.response === undefined && res.data.allow === true)  {
          setLoadInit(false);
          void loadSocieties();
        } else {
          setMsgRestricted(res.response.data.error);
        }
    };
    const loadSocieties = async () => {
      await dispatch(findSocieties(data.auth.id.user.userId));
      setShowLoadingSociety(true);
    };
    const loadBankingList = async (country) => {
      setShowLoadingBankingList(false);
      await dispatch(getBankingList(country));
      setShowLoadingBankingList(true);
    };
    const loadConciliationDaily = async(society) => {
        Moment.locale('es');
        setOpen(true);
        const json = {
          filter: {
            bankCode: dataFilter.banking.value === ""? "" : dataFilter.banking.value,
            dateIssue: conciliationData.history === true? getDateFormat(data.dateIssue):"",
          },
          option: data.optionConciliation,
          societyId: society
      }
        let res = await dispatch(getConciliationDaily(json));
        if(res.status === 200) {
          const result = res.data;
          conciliationData.totalDaily.bank = Number.parseFloat(result.amountTotalBank).toFixed(2);
          conciliationData.totalDaily.income = Number.parseFloat(result.amountTotalIncome).toFixed(2);
          conciliationData.totalDaily.coin = result.coinName;
          conciliationData.totalDaily.sizeBank = result.sizeLsBank;
          conciliationData.totalDaily.sizeIncome = result.sizeLsIncome;
          conciliationData.totalDaily.dateIssue = Moment(result.dateIssue).format('dddd D MMMM YYYY');
          if(result.differenceAmount > 0) {
            conciliationData.totalDaily.difference = Number.parseFloat(result.differenceAmount).toFixed(2);
          } else {
            conciliationData.totalDaily.difference = 0;
            setMatchAmount(true);
            conciliationData.totalDaily.total = Number.parseFloat(result.total).toFixed(2);
          }
          if(conciliationData.totalDaily.sizeBank !== conciliationData.totalDaily.sizeIncome) {
            viewNotification(language.messages.conciliation.notEquals, 'warning');
            setMatchAmount(false);
          }
        } else {
          switch (res.status) {
            case 403:
              viewNotification(res.response.data.error, 'error');
              break;
            case 404:
              viewNotification(res.response.data.error, 'warning');
              break;
            default:
              viewNotification(language.messages.msmErrorExist, 'error');
              break;
          }
        }
        setOpen(false);
        setPendingServiceInit(false);
        refreshConciliationData();
    }
    //#endregion LOAD_DATA

    //#region FUNCTIONS
    const viewNotification = (msm, action) => {
        addToast(msm, {
            appearance: action,
            autoDismiss: true,
        });
    };
    const updateSelect = async (value, id) => {
      switch (id) {
        case 'society':
          clearEntityBank();
          if(data.optionConciliation === 'history'){
            conciliationData.history = false;
            data.optionConciliation = 'daily';
            refreshConciliationData();
            void loadConciliationDaily('');
          }
          data.society = value;
          data.selectedCountry = value.country;
          void loadBankingList(data.selectedCountry);
          refreshDataFilter();
          break;
        case 'banking':
          dataFilter.banking = value;
          data.selectedBanking = value.value;
          refreshDataFilter();
          setPendingServiceInit(true);
          void loadConciliationDaily(data.society.value);
          break;
        default:break;
      }
    };
    const onChangeSelect = (value) => {
      conciliationData.history = value.target.checked;
      refreshConciliationData();
      if(conciliationData.history) {
        if(data.selectedCountry !== '' && data.selectedBanking !== '') {
          viewNotification(language.messages.switchOption.msmHistory, 'info');
          data.optionConciliation = 'history';
        } else {
          viewNotification(language.messages.switchOption.msmEmptySociety, 'warning');
          conciliationData.history = false;
          refreshConciliationData();
        }
      } else {
        viewNotification(language.messages.switchOption.msmDaily, 'info');
        data.optionConciliation = 'daily';
        setPendingServiceInit(true);
        void loadConciliationDaily(data.society.value);
      }
    };
    const onChangeDateIssue = (date) => {
      if(data.selectedCountry !== '' && data.selectedBanking !== '') {
        data.dateIssue = date._d;
        setPendingServiceInit(true);
        void loadConciliationDaily(data.society.value);
      } else viewNotification(language.messages.switchOption.msmEmptySociety, 'warning');
    };
    const getDateFormat = (date) => {
      const startMonth = date.getMonth() + 1 + '';
      const startDay = date.getDate() + '';
      const startDate = date.getFullYear() + '-' + startMonth.padStart(2, '0') + '-' + startDay.padStart(2, '0');
      return startDate;
  
    }
    const clearEntityBank = () => {
      dataFilter.banking.error = '';
      dataFilter.banking.value = '';
      dataFilter.banking.label = '';
      data.selectedBanking = '';

      dataFilter.errors = [];
    };
    //#endregion FUNCTIONS
    const renderConciliationDetail = () => {
      if (matchAmount===true) {
        return <PartialDaily data={data} columns={columns}/>;
      }
      return (
        <Row>
          <Col>
            <Tabs defaultActiveKey={1} id="tab-bank"><Tab eventKey={1} title={language.messages.tabConciliationDailyBank + " - "+ conciliationData.totalDaily.dateIssue}>
              <PartialBank data={data} />
            </Tab></Tabs>
          </Col>
          <Col>
            <Tabs defaultActiveKey={1} id="tab-income"><Tab eventKey={1} title={language.messages.tabConciliationDailyIncome + " - "+ conciliationData.totalDaily.dateIssue}>
              <PartialIncome data={data} />
            </Tab></Tabs>
          </Col>
        </Row>
      );
    };
    return (
        <Fragment>
        <SessionConfig ref={ref}/>
        {
            loadInit === true?<Container fluid={true}>
            <Row>
            <Col md={4}></Col>
            <Col md={4}>
                {msgRestricted !== ''?<Alert variant="danger">
                <Alert.Heading>{msgRestricted}!</Alert.Heading>
                <p>Por favor consulte con el administrador del sistema</p>
            </Alert>:<Lottie 
                style={{
                flex: 1, height: 300,  width: 300, padding: 0,
                margin: 0,
                }} animationData={loadingInit} />}
            </Col>
            <Col md={4}></Col>
            </Row>
            </Container>:
            <Container fluid={true}>
              <Backdrop className={classes.backdrop} open={open}>
                <Lottie 
                style={{
                flex: 1, height: 200,  width: 200, padding: 0,
                margin: 0,
                }} animationData={loadingInit} />
              </Backdrop>
              <Paper elevation={3} variant="outlined" className={classes.rootPaper} >
                <Row>
                  <Col xs={12} sm={5} md={5} lg={6}>
                    <Typography gutterBottom variant="h5">
                      {language.messages.gridConciliationDaily.lbConciliationSocietyDaily}
                    </Typography>
                  </Col>
                  <Col sm={2} md={2} lg={3}></Col>
                  <Col xs={12} sm={5} md={5} lg={3}>
                    <Typography component="div">
                      <Grid component="label" container alignItems="center" spacing={2}>
                        <Grid item>{language.messages.switchOption.daily}</Grid>
                        <Grid item>
                          <ConciliationSwitch checked={conciliationData.history} name="dailyConciliation" onChange={(value) => {
                            onChangeSelect(value); }}/>
                        </Grid>
                        <Grid item>{language.messages.switchOption.history}</Grid>
                      </Grid>
                    </Typography>
                    <Divider light />
                  </Col>
                </Row>
                <Fragment>
                  <Row>
                      <Col xs={12} sm={4} md={3} lg={2}>
                        <Row>
                          <LabelChargeData showloading={showLoadingSociety}/>
                        </Row>
                        <FormGroup>
                          <Select classNamePrefix="ui-select"
                            placeholder={language.messages.lblSingleSelect}
                            name="society"
                            options={data.societies}
                            className="text-uppercase small-font"
                            value={{
                              value: data.society.value,
                              label: data.society.label
                            }}
                            onChange={(value) => {
                              void updateSelect(value, 'society');
                            }}
                          />
                          <span className="small-font text-danger">
                            {data.society.error}
                          </span>
                        </FormGroup>
                        <FormGroup>
                          <Row>
                            <Col md={12}>
                              <LabelTitle text={language.messages.filterData.lblBankName} />
                            </Col>
                            <LabelChargeData showloading={showLoadingBankingList}/>
                          </Row>
                          <Select classNamePrefix="ui-select"
                            isDisabled={data.selectedCountry === ''}
                            placeholder={language.messages.lblSingleSelect}
                            name="banking"
                            options={dataFilter.bankingList}
                            className="text-uppercase small-font"
                            value={{
                              value: dataFilter.banking.value,
                              label: dataFilter.banking.label
                            }}
                            onChange={(value) => {
                              void updateSelect(value, 'banking');
                            }}
                          />
                          <span className="small-font text-danger">
                            {dataFilter.banking.error}
                          </span>
                        </FormGroup>
                        {conciliationData.history === true?<Row>
                            <Col>
                              <FormGroup>
                                <LabelTitle text={language.messages.switchOption.lblDateIssue} />
                                <Datetime
                                  timeFormat={false}
                                  initialValue={new Date()}
                                  onChange={onChangeDateIssue}
                                  //inputProps={{ readOnly: dataFilter.filterDate === false }}
                                  dateFormat="DD/MM/YYYY"
                                />
                              </FormGroup>
                            </Col>
                          </Row>:''
                        }
                      </Col>
                      <Col xs={12} sm={4} md={3} lg={3}>
                      <Card bg={'secondary'} text='white' className="mb-2">
                          <Card.Header><small>{dataFilter.banking.label.toLocaleUpperCase()}</small></Card.Header>
                          <Card.Body>
                            <Card.Title>{Number.parseFloat(conciliationData.totalDaily.bank).toLocaleString('en')}</Card.Title>
                            <small>{conciliationData.totalDaily.coin}</small>
                          </Card.Body>
                          <Card.Footer>
                            <small>{conciliationData.totalDaily.dateIssue}</small>
                          </Card.Footer>
                      </Card>
                      </Col>
                      <Col xs={12} sm={4} md={3} lg={3}>
                      <Card bg={'light'} text='dark' className="mb-2">
                          <Card.Header><small>{language.messages.lblCardTitleIncome}</small></Card.Header>
                          <Card.Body>
                            <Card.Title>{Number.parseFloat(conciliationData.totalDaily.income).toLocaleString('en')}</Card.Title>
                            <small>{conciliationData.totalDaily.coin}</small>
                          </Card.Body>
                          <Card.Footer>
                            <small>{conciliationData.totalDaily.dateIssue}</small>
                          </Card.Footer>
                      </Card>
                      </Col>
                      {
                          conciliationData.totalDaily.difference > 0? 
                          <Col xs={12} sm={12} md={3} lg={3}>
                          <Card bg={'danger'} text='white' className="mb-2">
                              <Card.Header><small>{language.messages.lblCardTitleConciliationError}</small></Card.Header>
                              <Card.Body>
                                <Card.Title>{Number.parseFloat(conciliationData.totalDaily.difference).toLocaleString('en')}</Card.Title>
                                <small>{conciliationData.totalDaily.coin}</small>
                              </Card.Body>
                              <Card.Footer>
                                <small>{conciliationData.totalDaily.dateIssue}</small>
                              </Card.Footer>
                          </Card>
                          </Col>:<Col xs={12} sm={12} md={3} lg={3}>
                          <Card bg={'success'} text='white' className="mb-2">
                              <Card.Header><small>{language.messages.lblCardTitleTotalConciliation}</small></Card.Header>
                              <Card.Body>
                                <Card.Title>{Number.parseFloat(conciliationData.totalDaily.total).toLocaleString('en')}</Card.Title>
                                <small>{conciliationData.totalDaily.coin}</small>
                              </Card.Body>
                              <Card.Footer>
                                <small>{conciliationData.totalDaily.dateIssue}</small>
                              </Card.Footer>
                          </Card>
                          </Col>
                      }                                
                  </Row>
                  {pendingServiceInit===false? renderConciliationDetail() :""}
                </Fragment>
              </Paper>
            </Container>
        }
        </Fragment>
    );
};
const App = () => (
  <ToastProvider>
    <ConciliationMonitor />
  </ToastProvider>
);
export default App;
